import { creditApi } from '@/shared/http';

import { permissionListSchema, type PermissionEntry } from './permission.wire';

/**
 * `getPermissionList(undefined, …)` do legado: `GET /Permission`, sem principal e **sem tenant**
 * (o legado só manda tenant quando consulta um principal).
 */
export async function getEffectivePermissions(signal?: AbortSignal): Promise<PermissionEntry[]> {
  const data = await creditApi.get<unknown>('/Permission', signal ? { signal } : {});
  const parsed = permissionListSchema.safeParse(data);
  if (parsed.success) return parsed.data;
  // U27: fio fora do contrato só avisa fora de produção e segue com o valor cru.
  if (!import.meta.env.PROD) console.warn('GET /Permission fora do contrato', parsed.error.issues);
  return Array.isArray(data) ? (data as PermissionEntry[]) : [];
}
